// Category labels mapping
export const CATEGORY_LABELS = {
  'assistant_virtuel': 'Assistant Virtuel',
  'community_manager': 'Community Manager',
  'gestion_ads': 'Gestion Ads / Traffic Manager',
  'seo': 'SEO / Référencement',
  'developpeur': 'Développeur / Tech',
  'graphiste': 'Graphiste / Designer',
  'redacteur': 'Rédacteur / Copywriter',
  'comptabilite': 'Comptabilité / Finance',
  'support_client': 'Support Client',
  'commercial': 'Commercial / Vente',
  'autre': 'Autre'
};

// Get primary category from candidate
export const getPrimaryCategory = (candidate) => {
  if (candidate?.primary_category) {
    return candidate.primary_category;
  }
  // Fallback: check job_categories array
  const categories = candidate?.job_categories || [];
  for (const cat of categories) {
    if (cat.is_primary) {
      return cat.category_id;
    }
  }
  return categories[0]?.category_id || 'autre';
};

// Get all categories as formatted string
export const getCategoriesDisplay = (candidate) => {
  const categories = candidate?.job_categories || [];
  if (categories.length === 0) {
    return 'Non défini';
  }
  return categories.map(cat => CATEGORY_LABELS[cat.category_id] || cat.category_id).join(', ');
};

// Determine the appropriate qualification form type based on candidate's category
export const determineQualificationFormType = (candidate) => {
  const primaryCategory = getPrimaryCategory(candidate);

  // Use qualification.form_type if already set
  if (candidate?.qualification?.form_type) {
    return {
      type: candidate.qualification.form_type,
      label: CATEGORY_LABELS[candidate.qualification.form_type] || candidate.qualification.form_type
    };
  }

  // Map category to form type
  const categoryFormMap = {
    'assistant_virtuel': { type: 'assistant_virtuel', label: 'Assistant Virtuel' },
    'community_manager': { type: 'community_manager', label: 'Community Manager' },
    'gestion_ads': { type: 'marketing_ads', label: 'Marketing/Ads' },
    'seo': { type: 'seo', label: 'SEO' },
    'developpeur': { type: 'talent_technique', label: 'Talent Technique' },
    'graphiste': { type: 'assistant_virtuel', label: 'Assistant Virtuel' },
    'redacteur': { type: 'assistant_virtuel', label: 'Assistant Virtuel' },
    'comptabilite': { type: 'assistant_virtuel', label: 'Assistant Virtuel' },
    'support_client': { type: 'assistant_virtuel', label: 'Assistant Virtuel' },
    'commercial': { type: 'assistant_virtuel', label: 'Assistant Virtuel' },
    'autre': { type: 'assistant_virtuel', label: 'Assistant Virtuel' }
  };

  return categoryFormMap[primaryCategory] || { type: 'assistant_virtuel', label: 'Assistant Virtuel' };
};

// Experience level badge computation
export const getExperienceBadge = (years) => {
  if (years <= 2) return { label: 'Junior', class: 'bg-level-junior text-white' };
  if (years <= 5) return { label: 'Intermédiaire', class: 'bg-level-confirme text-white' };
  return { label: 'Senior', class: 'bg-level-senior text-white' };
};
